export enum ListStatusCode {
  pending = 'pending',
  introduced = 'introduced',
  completed = 'completed'
}
